import React from 'react';
import Base from './Base';
import { Dropdown } from '@mui/base/Dropdown';
import { MenuButton } from '@mui/base/MenuButton';
import { Menu } from '@mui/base/Menu';
import { MenuItem } from '@mui/base/MenuItem';
import { ThemeContext } from './ThemeContext';
import { NavLink } from 'react-router-dom';

class CreateClosingDocument extends Base {
    constructor(props) {
        super(props);
        this.state = { data: { global: { company: null }, closingDocument: null, openingDocument: null }, loading: true };

        this.AnnualClosingDocument = this.AnnualClosingDocument.bind(this);
        this.AnnualOpeningDocument = this.AnnualOpeningDocument.bind(this);
    }

    componentDidMount() {
        this.httpPost("/api/v1/document/getClosingOpeningDocuments")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }


    AnnualClosingDocument() {
        this.httpPost("/api/v1/document/AnnualClosingDocument", {
            companyId: this.isNull(this.state.data.global.company) ? null : this.state.data.global.company.id
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage(data.message || 'سند اختتامیه با موفقیت صادر شد');

                    this.state.data.closingDocument = data.document;

                } else {
                    this.showErorrMessage(data.message || 'خطایی در زمان صدور سند اختتامیه رخ داده است');
                }
            })
            .catch(err => {
                this.showErorrMessage('خطایی در زمان صدور سند اختتامیه رخ داده است');
            });
    }
    AnnualOpeningDocument() {
        this.httpPost("/api/v1/document/AnnualOpeningDocument", {
            companyId: this.isNull(this.state.data.global.company) ? null : this.state.data.global.company.id
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage(data.message || 'سند افتتاحیه با موفقیت صادر شد');

                    this.state.data.openingDocument = data.document;

                } else {
                    this.showErorrMessage(data.message || 'خطایی در زمان صدور سند افتتاحیه رخ داده است');
                }
            })
            .catch(err => {
                this.showErorrMessage('خطایی در زمان صدور سند افتتاحیه رخ داده است');
            });
    }

    RemoveClosingDocument(id) {
        this.httpPost("api/v1/document/remove", {
            source: 1,
            id: id,
            companyId: (this.isNull(this.state.data.global.company) ? null : this.state.data.global.company.id),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
                    this.state.data.closingDocument = null;
                    this.setState({ data: this.state.data });
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    RemoveOpeningDocument(id) {
        this.httpPost("api/v1/document/remove", {
            source: 1,
            id: id,
            companyId: (this.isNull(this.state.data.global.company) ? null : this.state.data.global.company.id),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
                    this.state.data.openingDocument = null;
                    this.setState({ data: this.state.data });
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    render() {
        console.log(this.state)
        return (
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="card-title-group pb-1 g-2 chart-title-bg mt-2">

                                <div className="card-title me-1">
                                    <h6 className="title">صدور سند افتتاحیه</h6>
                                    <p style={{ margin: '0' }}>
                                        قبل از صدور سند افتتاحیه هر سال لازم است تمام اسناد مربوط به سال قبل بسته شده باشند و سند اختتامیه سال قبل زده شده باشد.
                                    </p>
                                    <p style={{ margin: '0' }}>
                                        در صورتی که سال اول فعایت شرکت است میبایست اقدام به صدور سند افتتاحیه به صورت دستی نمایید
                                    </p>
                                </div>



                                <div className="nk-block-head-content">
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                        <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                        <div className="toggle-expand-content" data-content="pageMenu">
                                            {!this.isNull(this.state.data.openingDocument) ?
                                                (
                                                    <Dropdown className="me-2">
                                                        <MenuButton className="btn btn-primary me-2">
                                                            <span>سند شماره {this.state.data.openingDocument.number}</span><em className="icon ni ni-chevron-down"></em>
                                                        </MenuButton>

                                                        <Menu className="link-list-plain">

                                                            <MenuItem>
                                                                <NavLink to={"/document/edit/" + this.state.data.openingDocument.id}>مشاهده سند</NavLink>
                                                            </MenuItem>

                                                            <MenuItem>
                                                                <a className="hand" onClick={e => this.RemoveOpeningDocument(this.state.data.openingDocument.id)}>حذف سند</a>
                                                            </MenuItem>
                                                        </Menu>
                                                    </Dropdown>
                                                ) :
                                                (
                                                    <div className="me-2" style={{ display: 'inline-flex' }}>

                                                        <a className="btn btn-primary " onClick={e => this.AnnualOpeningDocument()}>
                                                            <em className="icon ni ni-download-cloud"></em>
                                                            <span>صدور سند افتتاحیه</span>
                                                        </a>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-title-group pb-1 g-2 chart-title-bg mt-4 mb-4">
                                <div className="card-title me-1">
                                    <h6 className="title">صدور سند اختتامیه</h6>
                                    <p>قبل از صدور سند اختتامیه هر سال لازم است تمام اسناد مربوط به آن سال مالی را به حالت نهایی (دائمی) در آورید.</p>
                                </div>
                                <div className="nk-block-head-content">
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                        <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                        <div className="toggle-expand-content" data-content="pageMenu">
                                            {!this.isNull(this.state.data.closingDocument) ?
                                                (
                                                    <Dropdown className="me-2">
                                                        <MenuButton className="btn btn-primary me-2">
                                                            <span>سند شماره {this.state.data.closingDocument.number}</span><em className="icon ni ni-chevron-down"></em>
                                                        </MenuButton>

                                                        <Menu className="link-list-plain">

                                                            <MenuItem>
                                                                <NavLink to={"/document/edit/" + this.state.data.closingDocument.id}>مشاهده سند</NavLink>
                                                            </MenuItem>

                                                            <MenuItem>
                                                                <a className="hand" onClick={e => this.RemoveClosingDocument(this.state.data.closingDocument.id)}>حذف سند</a>
                                                            </MenuItem>
                                                        </Menu>
                                                    </Dropdown>
                                                ) :
                                                (
                                                    <div className="me-2" style={{ display: 'inline-flex' }}>

                                                        <a className="btn btn-primary " onClick={e => this.AnnualClosingDocument()}>
                                                            <em className="icon ni ni-download-cloud"></em>
                                                            <span>صدور سند اختتامیه</span>
                                                        </a>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>





                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default CreateClosingDocument;
